import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  OnChanges, ViewChild, ChangeDetectorRef,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import * as _ from 'lodash';

import { SearchService } from 'shared/search/search.service';
import { BrandService } from 'shared/brand/brand.service';
import { SearchModel } from 'shared/search/search.model';
import { PermissionsService } from 'shared/permissions/permissions.service';
import { ReturnRouteModel } from 'shared/return-route/return-route.model';
import { ReturnRouteService } from 'shared/return-route/return-route.service';
import { PreferencesService } from 'shared/preferences/preferences.service';

import { BaseSegmentComponent } from '../base/_base-segment.component';
import { DigitalAssetDetailsService } from '../../digital-asset-details.service';
import { AssignedSearchService } from './assigned-search.service';
import { MarketcopyAssignedSearchService } from './marketcopy-assigned-search.service';
import {columns, marketcopyRowData} from './columns';
import { Segment } from 'shared/segments-navigation/segment.interface';
import {AssetFieldItem, digitalAssetsSegmentData} from 'shared/digital-assets/digital-assets-segment-data';
import {marketingCopySegmentData} from '../../../global-pages/brand-information/segment-data/marketing-copy-segment-data';
import {AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {DomSanitizer} from '@angular/platform-browser';
import * as utils from 'utils/utils';
import {Core} from '../../../global-pages/brand-information/components/core/core.model';
import { Observable, Subject, of } from 'rxjs';
import {marketingCodeLookup} from 'utils/lookups';
import {MarketingCopyService} from 'shared/marketing-copy/marketing-copy.service';
import {DetailsControlType} from 'shared/details-page/details-control/details-control-type';
import {SearchWidgetComponent} from 'shared/search-widget/search-widget.component';
import {SortModel} from 'shared/search/sort.model';
import {SearchInputComponent} from 'shared/search/search-input/search-input.component';


@Component({
  moduleId: module.id,
  selector: 'assigned-segment',
  templateUrl: 'assigned.component.html',
  styleUrls: ['assigned.component.scss'],
})
export class AssignedComponent extends BaseSegmentComponent implements OnInit, OnChanges, OnDestroy {

  columns = columns;
  loading: BehaviorSubject<boolean>;
  navigationSegments: Array<Segment> = [
    {title: 'Products', active: true},
    {title: 'Market Copies', active: false},
  ];
  marketcopyRowData = marketcopyRowData;
  digitalAssetsSegmentData: Array<AssetFieldItem> = digitalAssetsSegmentData;
  marketingCopySegmentData: Array<AssetFieldItem> = marketingCopySegmentData;
  form: UntypedFormGroup;
  lookups: any = {};
  lookupsSubj: Observable<any>;

  @ViewChild(SearchInputComponent, {static: false})
  searchInput: SearchInputComponent;
  @ViewChild(SearchInputComponent, {static: false})
  marketcopySearchInput: SearchInputComponent;

  constructor(
    protected router: Router,
    private searchService: AssignedSearchService,
    private marketcopySearchService: MarketcopyAssignedSearchService,
    private marketingCopyService: MarketingCopyService,
    private brandService: BrandService,
    private preferencesService: PreferencesService,
    private fb: UntypedFormBuilder,
    protected digitalAssetDetailsService: DigitalAssetDetailsService,
    protected permissionsService: PermissionsService,
    protected route: ActivatedRoute,
    protected returnRouteService: ReturnRouteService,
    protected sanitizer: DomSanitizer,
    protected ref: ChangeDetectorRef,
  ) {
    super(digitalAssetDetailsService, permissionsService);
    this.form = this.fb.group({
      products: this.fb.array([]),
      marketcopy: this.fb.array([]),
    });
  }

  get id() {
    return this.assetDetail ? this.assetDetail._id : null;
  }

  get searchModel() {
    return this.searchService.searchModel;
  }

  get marketcopySearchModel() {
    return this.marketcopySearchService.searchModel;
  }

  get canViewItem() {
    return this.hasPermission(['admin', 'catalog-edit']);
  }

  get marketcopy(): UntypedFormArray {
    return this.form.get('marketcopy') as UntypedFormArray;
  }

  get formArray() {
    return this.marketcopy;
  }

  get products(): UntypedFormArray {
    return this.form.get('products') as UntypedFormArray;
  }

  get productsFormArray() {
    return this.products;
  }

  get isMarketcopySegment(): boolean {
    const marketcopySegment = this.navigationSegments.find(item => item.name === 'market-copies');
    return marketcopySegment.active === true;
  }

  /*******************************************
   * SEARCH COMPONENT GETTERS
   *******************************************/
  get currentPage(): number {
    return this.searchModel.currentPage;
  }
  get itemsPerPage(): number {
    return this.searchModel.itemsPerPage;
  }
  get currentSortModel(): SortModel {
    return this.searchModel.sortModel;
  }
  get searchResults(): Array<any> {
    return this.searchService.searchResults;
  }
  get selectedRows(): Array<any> {
    return this.searchService.selectedItems;
  }
  get selectedIds(): Array<any> {
    return this.searchService.selectedIds;
  }
  get searchValue(): string {
    return this.searchModel.searchValue;
  }
  get searchModelFilters(): Array<any> {
    return this.searchModel.filters;
  }
  get totalRecords(): number {
    return this.searchService.totalRecords;
  }
  get lastPage(): number {
    return this.searchModel.lastPage;
  }

  get marketcopyCurrentPage(): number {
    return this.marketcopySearchModel.currentPage;
  }
  get marketcopyItemsPerPage(): number {
    return this.marketcopySearchModel.itemsPerPage;
  }
  get marketcopyCurrentSortModel(): SortModel {
    return this.marketcopySearchModel.sortModel;
  }
  get marketcopySearchResults(): Array<any> {
    return this.marketcopySearchService.searchResults;
  }
  get marketcopySearchValue(): string {
    return this.marketcopySearchModel.searchValue;
  }
  get marketcopySearchModelFilters(): Array<any> {
    return this.marketcopySearchModel.filters;
  }
  get marketcopyTotalRecords(): number {
    return this.marketcopySearchService.totalRecords;
  }
  get marketcopyLastPage(): number {
    return this.marketcopySearchModel.lastPage;
  }


  /*******************************************
   * SEARCH COMPONENT HANDLERS
   *******************************************/


  ngOnInit() {
    this.loading = <BehaviorSubject<boolean>>new BehaviorSubject(false);
    this.lookupsSubj = this.fetchAssignmentLookups();
    this.initSearchModel();
  }

  ngOnChanges() {
    this.runProductsSearch();
    this.runMarketcopySearch();
  }

  ngOnDestroy() {
    this.searchService.clearSearchModel();
    this.marketcopySearchService.clearSearchModel();
  }

  runProductsSearch() {
    if (this.id) {
      this.loading.next(true);
      this.searchService.runSearchAssigned(this.brandService.getBrand(), this.id)
      .then(() => {
        this.setProductsFormArray();
        this.loading.next(false);
        this.ref.markForCheck();
      });
    }
  }

  runMarketcopySearch() {
    if (this.id) {
      this.loading.next(true);
      this.marketcopySearchService.runSearchMarketcopyAssigned(this.brandService.getBrand(), this.id)
      .then(() => {
        this.setFormArray();
        this.loading.next(false);
        this.ref.markForCheck();
      });
    }
  }

  /*******************************************
   * HANDLERS
   *******************************************/
  onLinkClick(data: any) {
    const _id = _.get(data, 'row._id');
    const item = _.find(this.searchResults, {_id});
    if (item) {
      this.returnRouteService.push(new ReturnRouteModel(`/digital-asset/${this.id}/assignments`, {}));
      // get preferences
      this.preferencesService.getPreferences()
      .subscribe((preferences: any) => {
       this.router.navigate([
         '/product-details-v2',
         item.itemId || 1,
         'digital-assets',
       ]);
      });
    }
  }

  onPaginationBtnClick(direction: number) {
    this.searchModel.currentPage += direction;
  }

  onSegmentSelect(segment: Segment) {
  }

  onProductClick(fieldName: string, formGroup: UntypedFormGroup) {
    if (fieldName !== 'partNumber') { return; }
    const _id = _.get(formGroup, 'value._id');
    const item = _.find(this.searchResults, {_id});
    if (!item) { return; }
    this.returnRouteService.push(new ReturnRouteModel(`/digital-asset/${this.id}/assignments`, {}));
    // get preferences
    this.preferencesService.getPreferences()
      .subscribe((preferences: any) => {
        this.router.navigate([
          '/product-details-v2',
          item.itemId || 1,
          'digital-assets',
        ]);
      });
  }

  onMarketcopyClick(fieldName: string) {
    if (fieldName === 'name') {
      this.router.navigate(['global-brand-information/marketing']);
    }
  }

  /*******************************************
   * SEGMENT TABLE METHODS
   *******************************************/

  setProductsFormArray(): void {
    if (!this.searchResults) { return; }
    const productsFGs = this.searchResults.map((item: any) => {
      return this.fb.group({
        part_image_small: new UntypedFormControl(item.part_image_small),
        thumbnail: new UntypedFormControl(item.part_image_small),
        partNumber: new UntypedFormControl(item.partNumber),
        descriptions: new UntypedFormControl(item.descriptions),
        file_type: new UntypedFormControl(item.file_type),
        actualProduct: new UntypedFormControl(item.actualProduct),
        _id: new UntypedFormControl(item._id),
      });
    });
    const formArray = this.fb.array(productsFGs);
    this.form.setControl('products', formArray);
  }

  setFormArray(): void {
    if (!this.marketcopySearchResults) { return; }
    const marketingFGs = this.marketcopySearchResults.map((item: any) => {
      return this.fb.group({
        name: new UntypedFormControl(item.name),
        code: new UntypedFormControl(item.code),
        reference: new UntypedFormControl(item.reference.toString()),
        // assetType: new FormControl(item.type),
        assetType: new UntypedFormControl(item.file_type),
        representation: new UntypedFormControl(item.representation),
      });
    });
    const formArray = this.fb.array(marketingFGs);
    this.form.setControl('marketcopy', formArray);
  }

  protected getTitle(name: string): string {
    // find title in rowData
    // @ts-ignore
    const colData = _.find(this.marketcopyRowData, {fieldName: name});
    if (_.get(colData, 'title')) { return colData.title; }

    // find title in segmentData
    const segmentData = [...this.digitalAssetsSegmentData, ...this.marketingCopySegmentData];
    const item = _.find(segmentData, {field_map: name});
    return item ? item.title : '';
  }

  protected getInvalidDot(fieldMap: string, formGroup: UntypedFormGroup, index: number) {
    const control = _.get(formGroup, `controls.${fieldMap}`);
    if (control.invalid) {
      return this.sanitizer.bypassSecurityTrustHtml(`
        <div class="circle-icon size-small cell-invalid-dot circle-red"
        data-ghost="cell-invalid-dot-${fieldMap}-${index}"></div>
      `);
    } else {
      return null;
    }
  }

  public fieldHintText(name: string): string {
    const item = this.getField(name);
    return item && item.hint_detail;
  }

  public fieldValidation(item: any, formGroup: UntypedFormGroup): any {
    if (!item) {
      return;
    }
    if (!item.validation || !formGroup) { return []; }
    const control = formGroup.controls[item.field_map];
    let validation: any = _.map(item.validation, (value: any, key: string) => {
      return {
        name: key,
        valid: control.valid,
      };
    });

    // PIES 6.7 validation row was added for test
    const pies65: any = _.find(validation, {name: 'PIES_6_5'});
    if (pies65) {
      validation = [...validation, {
        key: 'pies67',
        title: 'PIES 6.7',
        valid: pies65.valid,
      }];
    }
    return validation;
  }

  public fieldErrorDetail(item: any, formGroup: UntypedFormGroup) {
    if (!item || !item.title || !formGroup) { return ''; }
    const control = formGroup.controls[item.field_map];
    return this.controlErrorDetail(item, control);
  }

  public getField(fieldMap: string): any {
    const segmentData = [...this.digitalAssetsSegmentData, ...this.marketingCopySegmentData];
    return _.find(segmentData, {field_map: fieldMap});
  }

  public controlErrorDetail(item: any, control: AbstractControl) {
    if (!item || !item.title || !control) { return ''; }
    if (control.valid) { return ''; }
    if (control.errors) {
      const error = _.values(control.errors);
      if (_.isString(error[0])) { return error[0]; }
    }
    /*
    * TODO: We need to add ability to handle multiple validations.
    * Only for one validation now.
    */
    const keys  = _.keys(item.validation);
    if (!keys.length) { return ''; }
    return _.get(item, `validation.${keys[0]}.message`, '');
  }

  public getFieldLookup(fieldMap: string, codeValue?: string): any[] {
    const field: any = this.getField(fieldMap);
    if (field.field_map) {
      if (field.field_map === 'reference' && !!codeValue) {
        _.set(field, 'lookup', this.lookups[codeValue]);
      }
    }
    return field ? field.lookup : null;
  }

  private fetchAssignmentLookups(): Observable<any> {
    if (_.size(this.lookups)) { return of(this.lookups); }
    const subj = new Subject<any>();
    _.each(marketingCodeLookup, (item: any, index: number) => {
      this.marketingCopyService.fetchLookup(this.brandService.getBrand(), item.option)
        .subscribe((data: any = []) => {
          this.lookups[item.option] = data;
          if (index === marketingCodeLookup.length - 1) {
            subj.next(this.lookups);
            subj.complete();
          }
        });
    });
    return subj.asObservable();
  }

  getProductsValue(val, field): any {
    switch (field.col) {
      case 'description':
        return _.get(val, 'descriptions.DES.EN');
      case 'actualProduct':
        return 'Actual product';
      default:
        return val[field.col];
    }
  }

  /*******************************************
   * SEARCH COMPONENT METHODS
   *******************************************/
  private initSearchModel() {
    this.searchModel.itemsPerPage = 10;
    this.marketcopySearchModel.itemsPerPage = 10;
    this.ref.markForCheck();
  }
  onPageChange(page: number) {
    this.searchModel.currentPage = page;
    this.searchService._searchModel.next(this.searchModel);
    this.runProductsSearch();
  }
  onItemsPerPageChange(itemsPerPage: number) {
    this.searchModel.currentPage = 1;
    this.searchModel.itemsPerPage = itemsPerPage;
    this.searchService._searchModel.next(this.searchModel);
    this.runProductsSearch();
  }
  onSearchByTermClick() {
    this.searchByTerm(_.get(this.searchInput, 'searchTermValue'));
  }
  onClearSearchClick() {
    this.reset();
    this.searchModel.searchValue = '';
    this.searchService._searchModel.next(this.searchModel);
    this.runProductsSearch();
  }

  public reset(): void {
    this.searchService.searchResults = [];
    this.searchInput.resetValue();
  }
  public searchByTerm(searchTerm: string): void {
    this.searchModel.searchValue = searchTerm;
    this.ref.markForCheck();
    this.searchService._searchModel.next(this.searchModel);
    this.runProductsSearch();
  }
  onMarketcopyPageChange(page: number) {
    this.marketcopySearchModel.currentPage = page;
    this.runMarketcopySearch();
  }
  onMarketcopyItemsPerPageChange(itemsPerPage: number) {
    this.marketcopySearchModel.currentPage = 1;
    this.marketcopySearchModel.itemsPerPage = itemsPerPage;
    this.runMarketcopySearch();
  }
  onMarketcopySearchByTermClick() {
    this.marketcopySearchByTerm(_.get(this.marketcopySearchInput, 'searchTermValue'));
  }
  onMarketcopyClearSearchClick() {
    this.marketcopyReset();
    this.marketcopySearchModel.searchValue = '';
    this.runMarketcopySearch();
  }

  public marketcopyReset(): void {
    this.marketcopySearchService.searchResults = [];
    this.marketcopySearchInput.resetValue();
  }
  public marketcopySearchByTerm(searchTerm: string): void {
    this.marketcopySearchModel.searchValue = searchTerm;
    this.ref.markForCheck();
    this.runMarketcopySearch();
  }
}
